"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockHsExtoleService = exports.HsExtoleService = void 0;
const http_1 = require("@angular/common/http");
class HsExtoleService {
    constructor(http) {
        this.http = http;
        this.jwtEndpoint = '/rest-api/homeservices/v1/extolejwt';
        this.customerReferralEndpoint = '/rest-api/homeservices/v1/customerreferral';
    }
    createZone(tagName, elementid) {
        this.getCustomerReferralModel().subscribe((customerReferralModel) => {
            this.getNewToken().subscribe((jwtModel) => {
                extole.createZone({
                    name: tagName,
                    element_id: elementid,
                    data: {
                        first_name: customerReferralModel.firstName,
                        last_name: customerReferralModel.lastName,
                        email: customerReferralModel.email,
                        partner_user_id: customerReferralModel.partnerUserId,
                        labels: customerReferralModel.labels
                    },
                    jwt: jwtModel.jwt
                });
            });
        });
    }
    getNewToken() {
        return this.http.get(this.jwtEndpoint);
    }
    checkExistingToken(tokenModel) {
        return this.http.put(this.jwtEndpoint, tokenModel);
    }
    getCustomerReferralModel() {
        return this.http.get(this.customerReferralEndpoint);
    }
}
exports.HsExtoleService = HsExtoleService;
class MockHsExtoleService {
    createZone(tagName, elementid) {
        // mock: no necessary action needed
    }
}
exports.MockHsExtoleService = MockHsExtoleService;
//# sourceMappingURL=hs-extole.service.js.map